export default __webpack_public_path__ + "static/media/right-camels.90c696c3.png";